import i18n from 'modules/core/lib/i18n'

import { ActivationCenterResourceType } from 'modules/finance/components/FinancialWorkspace/components/ActivationCenter/enums'
import { UpsellProjectsButton } from 'modules/finance/components/FinancialWorkspace/components/UpsellProjects'
import { FROM_AC_COMPONENT } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/lib/trackConst'

const SOURCE_ID = 'activation_center_projects'

export const projectsResources = (available: boolean) => {
  const resources = {
    available: {
      label: i18n.t('finance.financial_workspace.activation_center.sources.projects'),
      type: ActivationCenterResourceType.FILLED,
      sourceId: SOURCE_ID,
    },
    unavailable: {
      label: i18n.t('finance.financial_workspace.activation_center.sources.projects'),
      type: ActivationCenterResourceType.NOT_ENABLED,
      button: UpsellProjectsButton({
        requestComponent: `${FROM_AC_COMPONENT}_projects`,
        buttonTexts: {
          requested: i18n.t(
            'finance.financial_workspace.activation_center.projects.button.requested'
          ),
          unlock: i18n.t('upselling_kit.button.more_info'),
        },
      }),
      sourceId: SOURCE_ID,
    },
  }

  return resources[available ? 'available' : 'unavailable']
}
